import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { Eye, EyeOff, Shield } from "lucide-react";
import "../../../assets/styles/admin/AdminLogin.css";
import { useNavigate } from "react-router-dom";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import Swal from "sweetalert2";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [isScreenLoading, setIsScreenLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const navigation = useNavigate();
  const { baseUrl, storeLoggedInAdmin } = useContext(AppContext);
  // const [formData, setFormData] = useState({
  //   email: "",
  //   password: "",
  // });
  // const [isLoading, setIsLoading] = useState(false);

  // const handleTogglePassword = () => {
  //   setShowPassword(!showPassword);
  // };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);

  //   // API call logic here
  //   setTimeout(() => {
  //     setIsLoading(false);
  //     console.log("Login Data:", formData);
  //   }, 1500);
  // };
  
  useEffect(() => {
    const admin = JSON.parse(localStorage.getItem("admin"));
    // const adminPassword = localStorage.getItem("adminPassword");
    if (admin != null) {
      autoLogin(admin);
    }
  }, []);

  const autoLogin = (admin) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("email", admin.email);
    formData.append("password", admin.password);
    axios
      .post(
        // "http://127.0.0.1:8000/api/admin/auth/loginadmin",
        `${baseUrl}/admin/auth/adminLogin`,
        formData,
        {
          "Content-type": "multipart-formdata",
        },
      )
      .then((response) => {
        if (response.data.success === true) {
          console.log(response.data);
          storeLoggedInAdmin(response.data.admin);
          navigate("/admin/dashboard");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const loginAdmin = () => {
    console.log("Login function called");
    console.log(email, password);
    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);
    axios
      .post(
        `${baseUrl}/admin/auth/adminLogin`,
        formData,
        {
          "Content-type": "multipart-formdata",
        },
      )
      .then((response) => {
        if (response.data.success == true) {
          console.log(response.data);
          // localStorage.setItem("adminEmail", email);
          // localStorage.setItem("adminPassword", password);
          localStorage.setItem("admin", JSON.stringify(response.data.admin));
          // localStorage.setItem("adminId", response.data.admin.id);
          storeLoggedInAdmin(response.data.admin);
          navigate("/admin/dashboard");
          Swal.fire({
            title: "Welcome Back!",
            text : "Hello How are you today!",
            icon : "success",
            confirmButtonText : "Close"
          })
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div className="admin-login-wrapper">
      <Container fluid className="admin-login-container">
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col xs={12} sm={10} md={8} lg={5} xl={4}>
            <div className="admin-login-card">
              {/* Icon Section */}
              <div className="admin-login-icon-wrapper">
                <div className="admin-login-icon-bg">
                  <Shield
                    className="admin-login-icon"
                    size={40}
                    strokeWidth={2.5}
                  />
                </div>
              </div>

              {/* Header Section */}
              <div className="admin-login-header">
                <h2 className="admin-login-title">Admin Login</h2>
                <p className="admin-login-subtitle">
                  Access the system management panel
                </p>
              </div>

              {/* Form Section */}
              <Form className="admin-login-form">
                {/* Email Field */}
                <Form.Group className="admin-login-form-group">
                  <Form.Label className="admin-login-label">Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="abc@gmail.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="admin-login-input has-icon"
                    required
                  />
                </Form.Group>

                {/* Password Field */}
                <Form.Group className="admin-login-form-group">
                  <Form.Label className="admin-login-label">
                    Password
                  </Form.Label>
                  <div className="admin-login-password-wrapper">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="········"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="admin-login-input"
                      required
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="admin-login-password-toggle"
                      aria-label="Toggle password visibility"
                    >
                      {showPassword ? (
                        <EyeOff size={20} className="admin-login-eye-icon" />
                      ) : (
                        <Eye size={20} className="admin-login-eye-icon" />
                        
                      )}
                    </button>
                  </div>
                </Form.Group>

                {/* Submit Button */}
                <Button
                  type="button"
                  className="admin-login-submit-btn"
                  disabled={isLoading}
                  onClick={loginAdmin}
                >
                  {isLoading ? (
                    <span className="admin-login-loading">
                      <span className="admin-login-spinner"></span>
                      logging In...
                    </span>
                  ) : (
                    "Login In"
                  )}
                </Button>
              </Form>

              {/* Footer */}
              <div className="admin-login-footer">
                <p className="admin-login-footer-text">
                  Need help?{" "}
                  <a href="#support" className="admin-login-footer-link">
                    Contact Support
                  </a>
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AdminLogin;
